export default __webpack_public_path__ + "static/pultrudedfrp-a7ac60fb8eb5b6239899cb6579da1f85.jpg";